<template>
  <base-dialog v-for="err in error" :key="err" :show="!!error" title="An error occurred" @close="handleError">
    <p>{{error}}</p>
  </base-dialog>

  <base-spinner v-if="isLoading"></base-spinner>


  <div class="container col-md-7 col-lg-5 login-page-card">
    <base-card>
      <div class="container">
        <img id="circle-logo" :src="circleIcon" alt=""/>
          <h1 id="welcome-text">Welcome to rtNOW</h1>
          <h4 class="mt-2"> Please login to your account </h4>
          <div v-if="googleClientId" class="mt-4">
            <google-button @callback="callback"></google-button>
          </div>

<!--          <p class="OR mt-3">OR</p>-->

<!--          <div style="text-align: left">-->
<!--            <label for="username" class="form-label">Email:</label>-->
<!--            <input v-on:keyup.enter="submitForm" type="email" class="form-control" id="username" placeholder="Enter Email" required v-model.trim="email"/>-->

<!--            <label for="password" class="form-label">Password:</label>-->
<!--            <input v-on:keyup.enter="submitForm" type="password" class="form-control" id="password" placeholder="Enter password" required v-model.trim="password"/>-->
<!--          </div>-->

<!--          <base-button mode="save" type="button" class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 mt-3" @click="submitForm">Login</base-button>-->
<!--          <input class="mt-3" type="checkbox" checked="checked"/> Remember me-->
<!--          <p class="OR mt-3">OR</p>-->
<!--          <router-link to="/resetPassword"> Forgot password? </router-link>-->

      </div>
    </base-card>
  </div>




</template>

<script>

import BaseDialog from "../../BaseComponents/BaseDialog";
import BaseSpinner from "../../BaseComponents/BaseSpinner";
import BaseCard from "../../BaseComponents/BaseCard";
import GoogleButton from  "./GoogleButton"


export default {
  components: {GoogleButton, BaseCard, BaseSpinner, BaseDialog},
  data() {
    return {
      email: '',
      password: '',
      error: null,
      isLoading: false,
      circleIcon: require('../../../assets/images/circle.png'),

    }
  },
  beforeMount() {
    this.$store.dispatch('auth/callToIndex');
  },
  computed: {
    isLoggedIn() {
      return this.$store.getters['auth/isAuthenticated'];
    },
    googleClientId(){
      return this.$store.getters['auth/getGoogleClientId']
    }
  },
  methods: {
    async submitForm() {
      this.isLoading = true;
      try {
        await this.$store.dispatch('login', {
          email: this.email,
          password: this.password,
        })
        await this.$router.push('/dashboard')
        await this.$router.go();
      } catch (error) {
        this.error = error.message || 'Failed to authenticate. Please check your email and password.';
      }
      this.isLoading = false;
    },
    handleError() {
      this.error = false;
    },
    loadUsers() {
      this.$store.dispatch('users/loadUsers')
    },
    async callback(response){
      try {
        let googleToken =  response.credential;
        this.isLoading = true;
        // sending the token to server
        await this.$store.dispatch("auth/sendGoogleToken", {
          googleToken: googleToken
        });
        this.isLoading = false;
        await this.$router.push('/dashboard')
      } catch (error) {
        this.error = error.message || 'Failed to authenticate';
        this.isLoading =false;
        console.log(error);
        return null;
      }
    },
  }
}


</script>

<style scoped>
.OR {
  display: flex;
  flex-direction: row;
}
.OR:before, .OR:after{
  content: "";
  flex: 1 1;
  border-bottom: 1px solid;
  margin: auto;
}
.OR:before {
  margin-right: 10px
}
.OR:after {
  margin-left: 10px
}
#circle-logo{
  width: 70px;
  height: 70px;
  margin-bottom: 10px;
}


</style>
